import { Toaster as Sonner, toast } from "sonner"
import "./sonner.css"

// Toasts in the Lyra style (sonner.css): white panel, hairline border, 4px corners, a coloured edge per kind.
// Always light — the portal has no dark theme.
const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="light"
      className="toaster lyra-toaster"
      toastOptions={{ classNames: { toast: "lyra-toast", description: "lyra-toast-description" } }}
      {...props} />
  );
}

export { Toaster, toast }
